const woSmartShare = ["5688", "4395", "5689", "4396", "5702", "4399", "5703", "4401", "5704", "4403", "5705", "4402", "5711", "4404", "5735", "4410", "5737", "4411", "5738", "4412", "5739", "4413", "5743", "4600", "7701", "6550", "7702", "6551", "7703", "6552", "7705", "6556", "7706", "6557", "7707", "6558", "7708", "6559"]

export const isnoSmartShare = (clientId) => {
    if (woSmartShare.includes(clientId)) return true
    else return false
}